import userRepository from '@/repositories/user.repository';
import { useMutation } from '@tanstack/react-query';

export function useStartUpdateUserCredential() {
  return useMutation({
    mutationFn: userRepository.startUpdateUserCredential,
  });
}

export function useConfirmUserCredentialMutation() {
  return useMutation({
    mutationFn: userRepository.confirmUserCredential,
  });
}
